// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreateEmployeeDeductionInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/create_employee_deduction
 *
 * Validates input for creating a new employee deduction.
 */
import { registerContract } from './validate'

export interface Payroll_CreateEmployeeDeductionInput {
employee_id: string
franchise_id: number
title: string
amount: number
deduction_date: string
description?: string
}

registerContract('Payroll_CreateEmployeeDeductionInput', {
  employee_id:    { type: 'string',  required: true },
  franchise_id:   { type: 'number',  required: true },
  title:          { type: 'string',  required: true },
  amount:         { type: 'number',  required: true },
  deduction_date: { type: 'string',  required: true },
  description:    { type: 'string',  required: false },
})
